import React from "react";
import { Route, Routes } from "react-router-dom";
import SingleNewsPage from "./SingleNewsPage";
import AllNews from "./AllNews";

export default function NewsRouter() {
    return (
        <Routes>
            <Route path="/" element={<AllNews />} />
            <Route path="/:id" element={<SingleNewsPage />} />
        </Routes>
    );
}
